import { atom } from 'recoil';
import { CustomersListType } from '../interfaces/Customer';

export const CustomersListState = atom<CustomersListType>({
  key: 'CustomersListState',
  default: {
    list: null,
  },
});
